<mat-expansion-panel [hideToggle]="true" #expansionPanel [disabled]="expansionPanelDisabled">
  <mat-expansion-panel-header
    collapsedHeight="75px"
    class="timer-expansion-panel"
    (contextmenu)="openContextMenu($event)"
    >
    <div
      class="context-menu"
      [style.left]="contextMenuPosition.x"
      [style.top]="contextMenuPosition.y"
      [matMenuTriggerFor]="rootmenu"
      >
    </div>
    <mat-card appearance="outlined">
      <mat-card-header>
        @if (timer.syncedWithJira && !pinned && !autoStopped) {
          <div
            mat-card-avatar
            class="synced-button-container"
            >
            <button
              mat-mini-fab
              color="primary"
              [disableRipple]="true"
              >
              <mat-icon matTooltip="Synchronisiert mit Jira">sync</mat-icon>
            </button>
          </div>
        }
        @if (!timer.syncedWithJira && timer.syncedWithJira !== undefined && timer.syncedWithJira !== null && !pinned && !autoStopped) {
          <div
            mat-card-avatar
            class="synced-error-button-container"
            >
            <button
              mat-mini-fab
              color="warn"
              (click)="syncTimerWithJira(); $event.stopPropagation();"
              >
              <mat-icon matTooltip="Erneut synchronisieren">sync_problem</mat-icon>
            </button>
          </div>
        }
        <mat-card-title [matTooltip]="!timer.description ? timer.name : null">
          <a
            [attr.href]="environment.jiraDomain + '/browse/' + timer.name"
            (click)="$event.stopPropagation()"
            style="color: white; text-decoration: none;"
            >
            {{ timer.name }}
          </a>
        </mat-card-title>
        @if (timer.description) {
          <mat-card-subtitle [matTooltip]="timer.description">
            {{ timer.description }}
          </mat-card-subtitle>
        }
      </mat-card-header>

      @if (!pinned && !autoStopped) {
        <mat-card-content>
          @if (timer.alarm) {
            <div class="alarm-duration">
              <mat-icon matTooltip="Alarm">alarm</mat-icon>
              {{ alarmDuration$ | async }}
            </div>
          }
          <div class="timer-duration">
            <mat-icon matTooltip="Timer Laufzeit">timer</mat-icon>
            {{ timerDuration | async }}
          </div>
        </mat-card-content>
      }

      <div class="timer-buttons">
        @if (!readonly && !autoStopped && !showLoadingSpinner) {
          <button
            mat-mini-fab
            [color]="timerService.isActiveTimer(timer) ? 'accent' : 'primary'"
            class="play-button"
            (click)="playPauseTimer(); $event.stopPropagation();"
            >
            @if (timerService.isActiveTimer(timer)) {
              <mat-icon>pause</mat-icon>
            } @else {
              <mat-icon>play_arrow</mat-icon>
            }
          </button>
        }

        @if (showLoadingSpinner) {
          <mat-progress-spinner
            color="primary"
            diameter="50"
            mode="determinate"
            [value]="syncProgress"
          ></mat-progress-spinner>
        }

        @if (!readonly && !pinned) {
          <button mat-icon-button [matMenuTriggerFor]="rootmenu"
            (click)="$event.stopPropagation();">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #rootmenu="matMenu" [overlapTrigger]="false">
          @if (!autoStopped) {
            <button mat-menu-item [matMenuTriggerFor]="alarmMenu">
              <mat-icon>alarm</mat-icon>
              Alarm
            </button>
          }
          @if (!autoStopped) {
            <button mat-menu-item [matMenuTriggerFor]="syncMenu">
              <mat-icon>sync</mat-icon>
              Mit Jira synchronisieren
            </button>
          }
          @if (!timerService.isActiveTimer(timer)) {
            <button mat-menu-item (click)="openEditDialog()">
              <mat-icon>edit</mat-icon>
              Zeiten ändern
            </button>
          }
          @if ((timer.syncedWithJira === undefined || timer.syncedWithJira === null) && !autoStopped) {
            <button
              mat-menu-item
              (click)="openEditNameDialog()"
              >
              <mat-icon>title</mat-icon>
              Umbenennen
            </button>
          }
          @if (!autoStopped) {
            <button mat-menu-item (click)="openAddDurationDialog()">
              <mat-icon>add_circle_outline</mat-icon>
              Zeit hinzufügen
            </button>
          }
          @if ((timer.syncedWithJira === undefined || timer.syncedWithJira === null) && !autoStopped) {
            <button
              mat-menu-item
              (click)="openDeleteTimerConfirmDialog()"
              >
              <mat-icon>delete_forever</mat-icon>
              Löschen
            </button>
          }
        </mat-menu>
        <mat-menu #alarmMenu="matMenu">
          @if (!timer.alarm) {
            <button mat-menu-item (click)="openAlarmDialog()">
              <mat-icon>alarm_add</mat-icon>
              Alarm hinzufügen
            </button>
          } @else {
            <button mat-menu-item (click)="openEditAlarmDialog()">
              <mat-icon>edit</mat-icon>
              Alarm bearbeiten
            </button>
            <button mat-menu-item (click)="openDeleteAlarmConfirmDialog()">
              <mat-icon>alarm_off</mat-icon>
              Alarm löschen
            </button>
          }
        </mat-menu>
        <mat-menu #syncMenu="matMenu">
          <button mat-menu-item (click)="syncTimerWithJira()">
            <mat-icon>timer</mat-icon>
            Timer
          </button>
          <button mat-menu-item (click)="syncFailedDurationsWithJira()">
            <mat-icon>sync_problem</mat-icon>
            Fehlgeschlagene Zeiten
          </button>
          <button mat-menu-item (click)="syncTimerDurationsFromDate()">
            <mat-icon>update</mat-icon>
            Sichtbare Zeiten
          </button>
        </mat-menu>
        @if (!autoStopped) {
          <button mat-icon-button>
            @if (!timer.pinned) {
              <mat-icon (click)="timerService.pinTimer(timer); $event.stopPropagation()">
                bookmark_border
              </mat-icon>
            } @else {
              <mat-icon (click)="timerService.unpinTimer(timer); $event.stopPropagation()">bookmark
              </mat-icon>
            }
          </button>
        }
      </div>
    </mat-card>
    @if (!pinned && !autoStopped) {
      <div class="arrow-down-panel"
        [style.visibility]="!expansionPanel.expanded ? 'visible' : 'hidden'">
        <mat-icon>expand_more</mat-icon>
      </div>
    }
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    @if (!pinned) {
      <nx-durations-list [readonly]="readonly" [timer]="timer"></nx-durations-list>
    }
  </ng-template>
  @if (expansionPanel.expanded && !pinned && !autoStopped) {
    <div class="arrow-up-panel">
      <mat-icon (click)="expansionPanel.close()">expand_less</mat-icon>
    </div>
  }
</mat-expansion-panel>
